var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "newVue" }, [
    _vm.loadingGet
      ? _c(
          "div",
          { staticClass: "text-xs-center" },
          [
            _c("v-progress-circular", {
              staticClass: "primary--text",
              attrs: { indeterminate: "", size: 100, width: 1 }
            })
          ],
          1
        )
      : _c(
          "div",
          [
            _c(
              "v-expansion-panel",
              _vm._l(_vm.mapping, function(site, i) {
                return _vm.GET_SITE_BY_ID(site.LIC_ID)
                  ? _c(
                      "v-expansion-panel-content",
                      { key: i },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "header" }, slot: "header" },
                          [
                            _vm._v(_vm._s(site.LIC_COMMENT) + " "),
                            _c("code", [_vm._v(_vm._s(site.LIC_URL))])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-card",
                          [
                            [
                              _c(
                                "v-card",
                                { staticClass: "grey lighten-4 elevation-0" },
                                [
                                  _c(
                                    "v-card-text",
                                    [
                                      _c(
                                        "v-container",
                                        { attrs: { fluid: "" } },
                                        [
                                          _c("wz-select-agents", {
                                            attrs: {
                                              withoutMe: "",
                                              agents:
                                                _vm.mapping[i].LIC_USR_LIST,
                                              agentsInit:
                                                _vm.mapping[i].LIC_USR_LIST
                                            },
                                            on: {
                                              "update:agents": function(
                                                $event
                                              ) {
                                                return _vm.$set(
                                                  _vm.mapping[i],
                                                  "LIC_USR_LIST",
                                                  $event
                                                )
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          ],
                          2
                        )
                      ],
                      1
                    )
                  : _vm._e()
              }),
              1
            )
          ],
          1
        ),
    _vm._v(" "),
    !_vm.loadingGet
      ? _c(
          "div",
          { staticClass: "text-xs-right" },
          [
            _c(
              "v-btn",
              {
                attrs: { color: "primary", loading: _vm.loadingPost },
                nativeOn: {
                  click: function($event) {
                    return _vm.submit.apply(null, arguments)
                  }
                }
              },
              [
                _vm._v("\n      " + _vm._s(_vm._f("cap")(_vm.$t("save")))),
                _c("v-icon", { attrs: { dark: "", right: "" } }, [
                  _vm._v("send")
                ])
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a63ef01c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a63ef01c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/management/Mapping.vue
// module id = null
// module chunks = 